module.exports = __webpack_public_path__ + "Roboto-Regular.61b6414b3618c2332c99.woff";


//////////////////
// WEBPACK FOOTER
// D:/V1/er.web.candidateconsole/src/assets/fonts/Roboto-Regular.woff
// module id = ../../../../../src/assets/fonts/Roboto-Regular.woff
// module chunks = styles